import * as FileSystem from "expo-file-system/legacy";
import * as Sharing from "expo-sharing";
import { Platform, Share } from "react-native";

export async function onShareQR(svgString: string) {
  if (Platform.OS === "web") {
    downloadSvgWeb(svgString);
    return;
  }
  if (FileSystem.cacheDirectory !== null) {
    const url = FileSystem.cacheDirectory + "/qr.svg";
    await FileSystem.writeAsStringAsync(url, svgString, {
      encoding: FileSystem.EncodingType.UTF8,
    });
    if (Platform.OS === "ios") {
      await Share.share({
        message: "QR-kod",
        url,
      });
    } else {
      if (!(await Sharing.isAvailableAsync())) {
        return;
      }
      await Sharing.shareAsync(url, {
        UTI: "public.image",
      });
    }
  }
}

function downloadSvgWeb(svgString: string, filename = "qr-code.svg") {
  const blob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();

  a.remove();
  URL.revokeObjectURL(url);
}
